// extracted by mini-css-extract-plugin
export var icons = "moreOpts-module--icons--hfTLw";
export var right = "moreOpts-module--right--qbeFK";
export var root = "moreOpts-module--root---oE0j";
export var swiperOuter = "moreOpts-module--swiperOuter--OtiV4";